import { EpimsBaseEntityDto } from "./epim-base.dto";
export class IncidentActivityDto extends EpimsBaseEntityDto {
  EventTypeId: string;
  ActivityName: string;
  ActivityDesc: string;
  SubscriptionUserId: string;  
  Version: number;
}